import templateUrl from 'emun.on-demand/media/od-media-fieldset.htm'
import controller from 'emun.on-demand/media/od-media-fieldset.controller'

const MediaFieldsetComponent = {
    bindings: {
        request: '<media',
        hideLabel: '@',
        hideTags: '@',
        hideDescription: '@',
        hideRating: '@',
        type: '&'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default MediaFieldsetComponent;
